interface ProjectsType {
  title: string
  description: string
  image: string
  GitHub: string
  hosted: string
  tags: Array<String>
}

export const ProjectsData: ProjectsType[] = [
  {
    title: 'Helper Webex Assistant Skill',
    description: `Helper is a Webex Assistant Skill, which on trigger provides day's news headlines, weather in a specific area and device booking details`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/helper-image.png?v=1695800742366',
    GitHub: 'https://github.com/rajitha123k/helper-webex-assistant-skill',
    hosted: '',
    tags: ['react', ''],
  },
  {
    title: 'Text Summarizer using Transformers',
    description: `This project uses machine learning model that can generate accurate and concise summaries of news articles from various sources, providing individuals with quick and easy-to-digest information about the day's top stories.`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/text-summary.png?v=1695801104144',
    GitHub: 'https://github.com/rajitha123k/text-summarizer-bbc-dataset',
    hosted: '',
    tags: ['react', ''],
  },
  {
    title: 'My Portfolio',
    description: `Portfolio website built with React v18.2, Typescript, framer-motion, react-fontawesome, react-icons, Scss`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/my-portfolio.png?v=1669731805178',
    GitHub: 'https://github.com/rajitha123k/personal-portfolio',
    hosted: '',
    tags: ['react', ''],
  },
  {
    title: 'Embeddable Meetings Widget',
    description: `Enables the user to embed the webex meetings widget with just a few lines of HTML code`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/meetings-widget.png?v=1669735712069',
    GitHub: 'https://github.com/rajitha123k/embeddable-meetings-widget',
    hosted: `https://wxsd-sales.github.io/meetings-widget-code-generator-demo/`,
    tags: ['react', 'portfolio'],
  },
  {
    title: 'Hanna Bot',
    description: `War room assistant bot designed to help with incident response workflows`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/hanna-bot.jpg?v=1669737754319',
    GitHub: 'https://github.com/wxsd-sales/war-room-assiatant-bot',
    hosted: '',
    tags: ['react', ''],
  },

  {
    title: 'Speed Tracking Android App',
    description: `This demo provides an illustration on how the android app can be blocked from usage while driving and also set the Webex status of the driver to Donot Disturb and custom status to Driving`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/speed_tarcker.png?v=1695800939591',
    GitHub: 'https://github.com/rajitha123k/speed-tracking-android-app',
    hosted: '',
    tags: ['react', ''],
  },
  {
    title: 'Chat and Meet Support Assistant',
    description: `Android app to connect to a professional with a provided instant chat and video calling assistance.`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/chat-and-meet-support-assistant.PNG?v=1695801560764',
    GitHub: 'https://github.com/wxsd-sales/chat-and-meet-support-assistant',
    hosted: ``,
    tags: ['react', ''],
  },
  {
    title: 'Report Issue Bot',
    description: `Report Issue macro and bot help the user report an issue using webex devices, which generates a issue card notification on the technical experts end using Webex team space.`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/report-issue.png?v=1695801798037',
    GitHub: 'https://github.com/wxsd-sales/report-issue-macro-and-bot',
    hosted: ``,
    tags: ['react', ''],
  },
  {
    title: 'MeTube',
    description: `Modified Version of Popular Youtube System`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/metube.png?v=1669731462158',
    GitHub: 'https://github.com/rajitha123k/MeTube',
    hosted: '',
    tags: ['react', ''],
  },
  {
    title: 'Peer Support',
    description: `Community-based peer to peer mental health therapy platform built using Webex Android SDK`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/support_groups.jpg?v=1669737863870',
    GitHub: 'https://github.com/wxsd-sales/peer-support',
    hosted: ``,
    tags: ['react', ''],
  },
  {
    title: 'Webex Android SDK Demo App',
    description: `Introduction on how to begin building Android applications with meetings, messaging and other basic features, using the Webex Android SDK.`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/android_demo_app.PNG?v=1695801437761',
    GitHub: 'https://github.com/wxsd-sales/android-sdk-demo-app',
    hosted: ``,
    tags: ['react', ''],
  },
  {
    title: 'Dee-tech',
    description: `Smart Watch to distinguish helpful and harmful UV rays and also predict the levels of vitamin D obtained by the user`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/deetech.png?v=1669738110821',
    GitHub: 'https://github.com/rajitha123k/Dee-tech',
    hosted: ``,
    tags: ['react', ''],
  },
  {
    title: 'Traffic Sign Classification',
    description: `Classify the traffic signs using CNN and GAN algorithms`,
    image:
      'https://cdn.glitch.global/9d61d6d3-fe2d-454a-8661-2a5ac9778baa/gan_github.jpg?v=1669731449337',
    GitHub: 'https://github.com/rajitha123k/TrafficSignClassificationCNN',
    hosted: ``,
    tags: ['react', ''],
  },
]
